import React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField, } from "@material-ui/core";
import { usePlaylistTitleEdit } from "frontend/src/domain/playlists";
export var PlaylistCreateModal = function (_a) {
    var isOpen = _a.isOpen, close = _a.close, create = _a.create, isLoading = _a.isLoading;
    var title = usePlaylistTitleEdit("");
    var _b = React.useState([]), playlists = _b[0], setPlaylists = _b[1];
    var onAutocompleteChange = function (playlist) {
        return setPlaylists(playlists.concat(playlist));
    };
    var onDeleteButtonClick = function (index) {
        return setPlaylists(playlists.filter(function (_, idx) { return idx !== index; }));
    };
    var onTitleChange = function (evt) {
        return title.set(evt.target.value);
    };
    var onCreateButtonClick = function () {
        var isValid = title.validate();
        if (isValid) {
            create({
                type: "public",
                title: title.value,
                isPublished: false,
                businessTypes: [],
                image: null,
                tracks: [],
            });
        }
    };
    return (React.createElement(Dialog, { open: isOpen, onClose: close, maxWidth: "md", fullWidth: true },
        React.createElement(DialogTitle, null, "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u043F\u043B\u0435\u0439\u043B\u0438\u0441\u0442"),
        React.createElement(DialogContent, null,
            React.createElement(TextField, { fullWidth: true, value: title.value, label: "Название плейлиста", error: Boolean(title.error.value), helperText: title.error.message, onChange: onTitleChange })),
        React.createElement(DialogActions, null,
            React.createElement(Button, { onClick: close, color: "primary", variant: "outlined" }, "\u041E\u0442\u043C\u0435\u043D\u0438\u0442\u044C"),
            React.createElement(Button, { onClick: onCreateButtonClick, color: "primary", autoFocus: true, variant: "contained", disabled: isLoading }, "\u0421\u043E\u0437\u0434\u0430\u0442\u044C"))));
};
